<template>
<div id="apptable" v-cloak>

    <b-card header="Eventi" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
        <div class="text-left">

            <div class="my-1 row">
                <div class="col-md-3">
                    <b-form-input v-model="filter" placeholder="Cerca..." />
                </div>
                <div class="col-md-9 text-right">
                    <b-button style="margin:1px 0px 1px 2px;" size="md" variant="outline-secondary" @click.stop="exportCSV()">
                        Esporta CSV
                    </b-button>
                    <b-button style="margin:1px 0px 1px 2px;" size="md" variant="outline-primary" @click.stop="insert()">
                        Inserisci
                    </b-button>
                </div>
            </div>

            <!-- Main table element -->
            <b-table responsive v-show="showtable" id="main-table" striped hover show-empty :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered" empty-text="Non sono stati trovati record da visualizzare" empty-filtered-text="Non sono stati trovati record corrispondenti alla tua richiesta">
                <template slot="id" scope="row">{{row.value}}</template>
                <template slot="id_evento_api" scope="row">{{row.value}}</template>
                <template slot="descrizione" scope="row">{{row.value}}</template>
                <template slot="uteins" scope="row">{{row.value}}</template>
                <template slot="datains" scope="row">{{row.value | formatDate}}</template>
      
                <template slot="modifica" scope="row">
                    <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->
                    <b-btn style="margin:0px 0px 1px 2px;" variant="warning" size="sm" @click.stop="del(row.item,row.index,$event.target)">Elimina</b-btn>
                </template>

            </b-table>

            <div class="row my-1">
                <div class="col-md-8 col-sm-12">
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
                </div>
                <div class="col-md-4 col-sm-12 text-right">
                    <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                        <b-form-select :options="pageOptions" v-model="perPage" />
                    </b-form-fieldset>
                </div>
            </div>
        </div>

        <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>

    </b-card>

    <!-- Modal Component -->
    <b-modal v-model="deleteModal.show" title="Elimina">
        <p class="my-2">Confermi l'eliminazione dell'Evento No Sync #{{deleteModal.id}}: {{deleteModal.titolo}}?</p>
        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="primary" @click="delItem()" style="margin: 2px;">
                Conferma
            </b-btn>
            <b-btn size="sm" class="float-right" variant="secondary" @click="deleteModal.show=false" style="margin: 2px;">
                Annulla
            </b-btn>
        </div>
    </b-modal>

        <!-- Modal Component -->
    <b-modal v-model="insertModal.show" title="Inserisci Evento No Sync">     

        <b-row class="my-1">
            <b-col sm="3"><label for="tipo">ID Evento API:</label></b-col>
            <b-col sm="9">
                    <b-form-input v-model="insertModal.eventonosync.id_evento_api" id="id_evento_api" type="number"></b-form-input>
            </b-col>
        </b-row>   

        <b-row class="my-1">
            <b-col sm="3"><label for="tipo">Descrizione (facoltativa):</label></b-col>
            <b-col sm="9">
                    <b-form-input v-model="insertModal.eventonosync.descrizione" id="descrizione" type="text"></b-form-input>
            </b-col>
        </b-row>   
        
        
<!--         <b-row class="my-1">
            <b-col sm="6">                                    
                <b-input-group prepend="ID Evento API">
                    <b-form-input v-model="insertModal.eventonosync.id_evento_api" id="id_evento_api" type="text"></b-form-input>
                </b-input-group>
            </b-col>
        </b-row>
        <b-row class="my-1">
            <b-col sm="6">                                    
                <b-input-group prepend="Descrizione (facoltativa)">
                    <b-form-input v-model="insertModal.eventonosync.descrizione" id="descrizione" type="text"></b-form-input>
                </b-input-group>
            </b-col>
        </b-row> -->


        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="primary" @click="insertItem()" style="margin: 2px;">
                Inserisci
            </b-btn>
            <b-btn size="sm" class="float-right" variant="secondary" @click="insertModal.show=false" style="margin: 2px;">
                Annulla
            </b-btn>
        </div>
    </b-modal>

</div>
</template>

<script>
import moment from 'moment'

import {
    NAMESPACE
} from '../config.js'



import {
    ctrlVismenu
} from '../util.js'

export default {
    name: 'apptable',
    data: function () {
        return {
            deleteModal: {
                id: null,
                titolo: '',
                show: false
            },
            insertModal: {
                eventonosync: {
                    descrizione: '',
                    id_evento_api: '',
                },
                show: false
            },
            items: [],
            namespace: NAMESPACE,
            fields: {
                id: {
                    label: '#',
                    sortable: true
                },
                id_evento_api: {
                    label: 'ID Evento API',
                    sortable: true
                },
                descrizione: {
                    label: 'Descrizione',
                    sortable: true
                },
                uteins: {
                    label: 'Utente inserimento',
                    sortable: true
                },
                datains: {
                    label: 'Data inserimento',
                    sortable: true
                },
                modifica: {
                    label: ' ',
                    'class': 'text-right'
                }
            },
            currentPage: 1,
            perPage: 10,
            pageOptions: [{
                text: 10,
                value: 10
            }, {
                text: 25,
                value: 25
            }, {
                text: 50,
                value: 50
            }],
            sortBy: null,
            sortDesc: false,
            totalRowsFilter: null,
            modalDetails: {
                index: '',
                data: ''
            },
            error: '',
            showerror: false,
            showtable: false,
        };
    },
    computed: {
        totalRows: {
            // getter
            get: function () {
                return this.totalRowsFilter || this.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.totalRowsFilter = newValue;
            }
        }
    },
    watch: {

    },
    filters: {
        formatDate: function (value) {
            if (!value) return '';
            return moment(String(value)).format('DD/MM/YYYY')
        }
    },
    methods: {
        exportCSV() {

            var apptable = this;

            if (this.items.length > 0) {
                var str = '"#";"ID Api Evento";"Descrizione";"Utente inserimento";"Data inserimento"\r\n';
                for (var i = 0; i < this.items.length; i++) {
                    str += '"' + this.items[i].id + '"' + ";";
                    str += '"' + this.items[i].id_evento_api + '"' + ";";
                    str += '"' + this.items[i].descrizione.replace(/\"/g, "\"\"") + '"' + ";";
                    str += '"' + this.items[i].uteins.replace(/\"/g, "\"\"") + '"' + ";";
                    str += '"' + apptable.$options.filters.formatDate(this.items[i].datains) + '"' + "\r\n";
                }

                var a = document.createElement('a');
                var blob = new Blob([str], {
                    'type': 'application\/octet-stream'
                });

                a.href = window.URL.createObjectURL(blob);
                a.download = 'eventi_' + moment(String(new Date())).format('YYYYMMDD_HHmmss') + '.csv';
                document.body.appendChild(a);
                a.click();
                setTimeout(function () {
                    document.body.removeChild(a);
                }, 100);

            }

        },
        insert() {
            this.insertModal.eventonosync = {
                descrizione: '',
                id_evento_api: '',
            };
            this.insertModal.show = true;
        },
        insertItem() {

            var json = JSON.stringify(this.insertModal.eventonosync);

            var token = localStorage.getItem('token');
            this.axios.post(NAMESPACE + 'rest/eventonosync', json, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {
                        if (!response.data.error) {
                            if (response.data.token != null) localStorage.setItem('token', response.data.token);
                
                            this.insertModal.show = false;

                            this.refreshData();

                        }
                        else {                             
                            throw new Error(response.data.message);
                        }
                    } catch (e) {
                       alert("Errore: " + e.message);
                    }
                })
                .catch(e => {
                       alert("Errore: " + e.message);
                });

        },
        
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        del(item, index, button) {
            this.deleteModal.id = item.id;
            this.deleteModal.titolo = item.descrizione;
            this.deleteModal.show = true;
        },
        delItem() {

            var token = localStorage.getItem('token');
            this.axios.delete(NAMESPACE + 'rest/eventinosync/' + this.deleteModal.id, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {
                        if (!response.data.error) {
                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            //forse può essere fatta diversamente e meglio
                            for (var i = 0; i < this.items.length; i++) {
                                if (this.items[i].id == this.deleteModal.id) {
                                    this.items.splice(i, 1); //delete
                                    break;
                                }
                            }
                            this.deleteModal.show = false;

                        } else {
                            throw new Error(response.data.message);
                        }
                    } catch (e) {
                        this.deleteModal.show = false;
                        this.showerror = true;
                        this.error = "Errore: " + e.message;
                    }
                })
                .catch(e => {
                    this.deleteModal.show = false;
                    this.showerror = true;
                    this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        },
        refreshData() {

            var token = localStorage.getItem('token');
            this.axios.get(NAMESPACE + `rest/eventinosync`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                // JSON responses are automatically parsed.
                try {

                    if (!response.data.error) {

                        if (response.data.token != null) localStorage.setItem('token', response.data.token);

                        this.items = response.data.message;     

                        this.showtable = true;

                    } else {
                        throw new Error(response.data.message);
                    }

                } catch (e) {
                    this.showerror = true;
                    this.error = "Errore: " + e.message;
                }

            })
            .catch(e => {
                this.showerror = true;
                this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
            });



        },

    },
    created: function () {

        if(!ctrlVismenu("E")){
            this.$router.replace('/accessdenied');
            return;
        }

        this.refreshData();

    }
}
</script>
